import { render } from "./loading.vue?vue&type=template&id=2bd737d5&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=2bd737d5&lang=less&scoped=true"

import exportComponent from "E:\\develop\\EBIEarthWebApp\\n-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd737d5"]])

export default __exports__